import { Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getRefundStats } from '../../api/refunds.api';
import DownloadButton from '../../components/DownloadButton';
import SimpleHeader from '../../components/layout/SimpleHeader';
import RefundSearch from '../../components/statistics/RefundSearch';
import useAxios from '../../hooks/useAxios';
import exportTable from '../../lib/exportTable';
import { getCommonCodeLabel } from '../../lib/store';
import { IGetRefundStats, IRefundStats } from '../../models/refunds.model';
import { RootState } from '../../store/rootReducer';
import moment from 'moment';
import { ISalesStatsParams } from '../../models/payments.model';
import useLoader from '../../hooks/useLoader';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';
import TableEmpty from '../../components/common/TableEmpty';

interface IRefundStatsTable extends IRefundStats {
  total: number;
}
const StatisticsRefund = () => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);

  const { data: res, isLoading, error, execute } = useAxios<IGetRefundStats>();
  //useLoader(isLoading, [error]);

  const [data, setData] = useState<IRefundStats[]>([]);

  useEffect(() => {
    if (res) {
      const _data: IRefundStatsTable[] = _.cloneDeep(res.data).map(item => ({
        ...item,
        total:
          item.tuition +
          item.onlineTuition +
          item.alexTuition +
          item.shuttleTuition +
          //item.examTuition +
          item.etcTuition,
      }));

      if (auth.hqYn === 'Y') {
        _data.push({
          campusCode: 'total',
          campusName: t('statistics.refund.1'),
          campusDiv: '',
          studentCount: _data.reduce(
            (acc: number, cur: any) => acc + cur.studentCount,
            0,
          ),
          tuition: _data.reduce(
            (acc: number, cur: any) => acc + cur.tuition,
            0,
          ),
          onlineTuition: _data.reduce(
            (acc: number, cur: any) => acc + cur.onlineTuition,
            0,
          ),
          alexTuition: _data.reduce(
            (acc: number, cur: any) => acc + cur.alexTuition,
            0,
          ),
          shuttleTuition: _data.reduce(
            (acc: number, cur: any) => acc + cur.shuttleTuition,
            0,
          ),
          examTuition: _data.reduce(
            (acc: number, cur: any) => acc + cur.examTuition,
            0,
          ),
          etcTuition: _data.reduce(
            (acc: number, cur: any) => acc + cur.etcTuition,
            0,
          ),
          total: _data.reduce((acc: number, cur: any) => acc + cur.total, 0),
        });
      }

      setData(_data);
    }
  }, [res]);

  const onSearch = (req: ISalesStatsParams) => {
    execute(getRefundStats(req));
  };

  const onExportTable = () => {
    const _data = _.cloneDeep(data);
    _data.forEach((item: any) => {
      item.campusDiv = getCommonCodeLabel('CA0003', item.campusDiv || '', 'ko');
    });
    const currentDate = moment(new Date());
    exportTable(columns, _data, `${t('statistics.refund.2')}_(${currentDate.format('YYYYMMDD')})`, t('statistics.refund.2'), [12, 10, 10, 15, 15, 17, 15, 15, 15, 15]);
  };

  const columns: TableColumnsType<IRefundStats> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusName',
      key: 'campusName',
      align: 'center',
    },
    {
      title: t('statistics.refund.column1'),
      dataIndex: 'campusDiv',
      key: 'campusDiv',
      align: 'center',
      render: (value) => getCommonCodeLabel('CA0003', value || '', 'ko'),
    },
    {
      title: t('statistics.refund.column2'),
      dataIndex: 'studentCount',
      key: 'studentCount',
      align: 'center',
      render: (value) => value?.toLocaleString(),
    },
    {
      title: t('statistics.sales.column1'),
      dataIndex: 'tuition',
      key: 'tuition',
      align: 'center',
      render: (value) => value?.toLocaleString(),
    },
    {
      title: t('statistics.sales.column2'),
      dataIndex: 'onlineTuition',
      key: 'onlineTuition',
      align: 'center',
      render: (value) => value?.toLocaleString(),
    },
    {
      title: t('statistics.refund.column3'),
      dataIndex: 'alexTuition',
      key: 'alexTuition',
      align: 'center',
      render: (value) => value?.toLocaleString(),
    },
    {
      title: t('statistics.sales.column5'),
      dataIndex: 'shuttleTuition',
      key: 'shuttleTuition',
      align: 'center',
      render: (value) => value?.toLocaleString(),
    },
    {
      title: t('statistics.refund.column5'),
      dataIndex: 'etcTuition',
      key: 'etcTuition',
      align: 'center',
      render: (value) => value?.toLocaleString(),
    },
    {
      title: t('statistics.refund.column6'),
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      render: (value) => value?.toLocaleString(),
    },
  ];

  return (
    <>
      <SimpleHeader
        iconFile="icon-statistics-big.svg"
        parentMenu={t('common.menu.statistics')}
        currentMenu={t('statistics.refund.title1')}
        onlyTitle={true}
      />
      <RefundSearch
        onSearch={onSearch}
      />
      <div className="content scrollbar">
        {isLoading && <Loader />}
        <ErrorResponse error={error} />

        {data.length ? (
          <div>
            <div className="comm-table__area">
            <Table
              columns={columns}
              dataSource={data}
              pagination={{
                current: 1,
                pageSize: 999999999,
              }}
              rowClassName={(record: IRefundStats) =>
                record.campusCode === 'total' ? 'tfoot' : ''
              }
            />
            </div>
            <div className="comm-bx__space">
              <DownloadButton onClick={onExportTable} />
            </div>
          </div>
        ) : (
            <TableEmpty text={t('statistics.appday.text1')} />
        )}
      </div>
    </>
  );
};

export default StatisticsRefund;